import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import classNames from 'classnames';

import Icon from '../../Icon';
import ActionButton from '../ActionButton';
import { COLORS } from '../../../constants/styles';

import styles from './index.styl';

const SimpleImagePreview = ({
  src,
  onCancel,
  handleClick,
  small,
  className,
  showCloseBtn,
  imageClassName,
}) => (
  <div
    styleName={classNames('root', {
      'root--small': small,
    })}
    className={className}
  >
    <img
      src={src}
      alt="preview"
      className={imageClassName}
      onClick={handleClick}
    />
    <If condition={showCloseBtn}>
      <div styleName="icon-close">
        <ActionButton onClick={onCancel} ariaLabel="close">
          <Icon name="close" size={24} style={{ fill: COLORS.white }} />
        </ActionButton>
      </div>
    </If>
  </div>
);

SimpleImagePreview.propTypes = {
  onCancel: PropTypes.func,
  handleClick: PropTypes.func,
  src: PropTypes.string,
  small: PropTypes.bool,
  className: PropTypes.string,
  imageClassName: PropTypes.string,
  showCloseBtn: PropTypes.bool,
};

SimpleImagePreview.defaultProps = {
  className: '',
  imageClassName: 'fit-cover',
  handleClick: () => {},
};

export default CSSModules(SimpleImagePreview, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/common/SimpleImagePreview/index.jsx